module.exports = __webpack_public_path__ + "static/media/md-time.130e75e7.svg";